/** Accent colors for stat / metric cards (matches product palette). */
export const StatAccent = {
  coral: "#E96B56",
  green: "#10B981",
  blue: "#3B82F6",
  amber: "#F59E0B",
} as const;

export type StatAccentKey = keyof typeof StatAccent;
